// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".cf16e71c0b449977e7a68d00a4451af2ac285f1e.chunk.js";
};